'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SettingsController = function () {
  /* @ngInject */
  function SettingsController($scope, $state, localStorageService, $translate) {
    _classCallCheck(this, SettingsController);

    this.$state = $state;
    this.localStorageService = localStorageService;
    this.$translate = $translate;

    // Prerequisites
    this.language = this.localStorageService.get('localeToUse') || 'de_DE';
  }

  /**
   * Language switch
   * @return {Void}
   */


  _createClass(SettingsController, [{
    key: 'languageSwitch',
    value: function languageSwitch() {
      // Switch language
      this.$translate.use(this.language);

      // Store in localStorage
      this.localStorageService.add('localeToUse', this.language);
    }
  }]);

  return SettingsController;
}();

exports.default = SettingsController;


/** WEBPACK FOOTER **
 ** ./src/app/components/settings/settings.controller.js
 **/